import React from 'react';
import { FaBoxes, FaVrCardboard, FaSyncAlt } from 'react-icons/fa';
import { FaFileExcel } from 'react-icons/fa6';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { exportDataInOutMaterials } from 'redux/erp/inventorySlice';
import { useNavigate } from 'react-router-dom';

const InOutMaterialHeader = ({ currentParams, refreshGrid }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleExport = async () => {
    await dispatch(exportDataInOutMaterials({
      startRow: 0,
      endRow: currentParams.rowCount,
      filterModel: currentParams.filterModel,
      sortModel: currentParams.sortModel,
      ...currentParams.customParams
    })).unwrap();
  };

  const handleInventoryTransactions = () => {
    navigate('/erp/inventory/transactions');
  }

  return (
    <div className="tw-mb-3">
      <div className="tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-gap-3">
        <div className="tw-flex tw-items-center tw-gap-3">
          <div className="tw-w-1.5 tw-h-10 tw-rounded-sm tw-flex-shrink-0" style={{ background: 'linear-gradient(to bottom, #0ea5e9, #6366f1)' }} />
          <div className="tw-flex tw-items-center tw-gap-2">
            <FaBoxes className="tw-text-blue-600" size={20} />
            <div>
              <h1 className="tw-mb-0 tw-font-bold tw-text-2xl tw-text-gray-900">In-Out Materials</h1>
              <p className="tw-text-gray-500 tw-text-sm tw-mb-0">Material stock balance by period — begin, in, out &amp; end quantities.</p>
            </div>
          </div>
        </div>

        <div className="tw-flex tw-items-center tw-gap-2">
          <button
            type="button"
            onClick={handleInventoryTransactions}
            className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-sm tw-border tw-border-blue-300 tw-bg-blue-50 tw-text-blue-700 hover:tw-bg-blue-100 tw-text-sm tw-font-medium tw-cursor-pointer"
          >
            <FaVrCardboard size={13} /> Transactions
          </button>
          <button
            type="button"
            onClick={refreshGrid}
            className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-sm tw-border tw-border-slate-300 tw-bg-white tw-text-slate-600 hover:tw-bg-slate-50 tw-text-sm tw-cursor-pointer"
          >
            <FaSyncAlt size={12} /> Reload
          </button>
          <button
            type="button"
            onClick={handleExport}
            className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-sm tw-border tw-border-green-300 tw-bg-green-50 tw-text-green-700 hover:tw-bg-green-100 tw-text-sm tw-font-medium tw-cursor-pointer"
          >
            <FaFileExcel size={13} /> Export
          </button>
        </div>
      </div>
    </div>
  );
};

InOutMaterialHeader.propTypes = {
  currentParams: PropTypes.object.isRequired,
  refreshGrid: PropTypes.func.isRequired,
  clearFilter: PropTypes.func,
  addRow: PropTypes.func
};

export default InOutMaterialHeader;
